import React from 'react';
// import PropTypes from 'prop-types';
// import { useQuery } from 'react-query';
import { Card, Typography } from 'antd';

const AlertsTab = () => (
  <Card
    // variant="borderless"
    bordered={false}
    title="Alerts"
    style={{
      backgroundColor: '#03304b', // TODO: replace with brand var
      border: '1px solid #4f6f81',
    }}
  >
    <Typography.Title
      level={5}
      style={{
        color: 'white',
      }}
    >
      Coming soon
    </Typography.Title>
  </Card>
);
AlertsTab.propTypes = {
};

AlertsTab.defaultProps = {
};

export default AlertsTab;
